export const decodeMatch = (match) => {
	return match ? {
		...match,
		params: Object.keys(match.params).reduce((params, paramKey) => {
			return {
				...params,
				[paramKey]: match.params[paramKey] ? decodeURI(match.params[paramKey]) : match.params[paramKey],
			}
		}, {}),
	} : match
}

export default decodeMatch;